import { FastlyImage } from '@components/common/image'
import Ratings from '@components/common/ratings'

export type whyCodingalType = {
  title: string
  description: string
}

type Props = {
  whyCodingal: whyCodingalType[]
}
const WhyCodingal = ({ whyCodingal }: Props) => {
  return (
    <div className="relative">
      <div className="absolute">
        {' '}
        <FastlyImage
          src="images/common/bg-gr.png"
          alt="Image"
          width={753}
          height={753}
        />
      </div>
      <div className="container mx-auto">
        <div className="flex flex-col items-center mt-10 pt-10 px-4 relative  md:mx-4 rounded-2xl">
          <p className="text-2xl text-center text-orange">Why Codingal?</p>
          <h2 className="pb-4 md:pb-0 pt-3 text-grey font-600 text-center text-2xl md:text-4xl">
            Learn By Doing With{' '}
            <span className="underlined-text">Expert Guidance</span>
          </h2>
          <div className="block md:hidden">
            <Ratings isDarkText />
          </div>
        </div>
        <div className="flex flex-wrap justify-center px-4 mb-10">
          {whyCodingal.map((whyCodingal, index) => (
            <div
              key={index}
              className="bg-white flex flex-col mx-2 my-6 relative shadow-lg hover:shadow-xl transition-all duration-200 rounded-md"
              style={{ width: '288px' }}
            >
              <div className="p-3 pt-4">
                <h3 className="mt-3 text-2xl font-700">{whyCodingal.title}</h3>
                <p className="mt-3 mb-3">{whyCodingal.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default WhyCodingal
